import { render, staticRenderFns } from "./CustomSwitcher.vue?vue&type=template&id=4e03836b"
import script from "./CustomSwitcher.vue?vue&type=script&lang=js"
export * from "./CustomSwitcher.vue?vue&type=script&lang=js"
import style0 from "./CustomSwitcher.vue?vue&type=style&index=0&id=4e03836b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports